
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

// Removed React.StrictMode to prevent double rendering that can trigger hook violations
createRoot(root).render(<App />);
